module.exports = __webpack_public_path__ + "img/ski_productimg.0ef36e8e.jpg";